"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-giacomo-filippo": {
    "f4daaa9c": [{
      "hkey": "18ecd3b4",
      "slug": "vho",
      "name": "Vho",
      "primary": true,
      "skipSearch": false
    }],
    "voh": [{
      "hkey": "18ecd3b4",
      "slug": "vho",
      "name": "Vho",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "96768a5a": [{
      "hkey": "b080ce15",
      "slug": "avero",
      "name": "Avero",
      "primary": true,
      "skipSearch": false
    }],
    "val-d-avero": [{
      "hkey": "b080ce15",
      "slug": "avero",
      "name": "Avero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;